<template>
  <div class="preview-container">
    <!-- 文件选择入口 -->
    <!-- <input
      v-if="!fileData"
      type="file"
      class="file-input"
      :accept="accept"
      @change="handleFileSelect"
    /> -->

    <!-- 预览内容容器 -->
    <div class="preview-content" :style="style">
      <div v-if="isLoading" class="preview-loading">加载中...</div>

      <!-- 图片预览 -->
      <div v-if="previewType === 'image'" class="preview-box">
        <!-- <img :src="previewContent" alt="图片预览" /> -->
        <el-image :style="style" :src="previewContent" fit="contain"></el-image>
      </div>

      <!-- PDF预览 -->
      <div v-if="previewType === 'pdf'" class="preview-box">
        <iframe :src="previewContent" class="pdf-viewer"></iframe>
      </div>

      <!-- 音频预览 -->
      <div v-if="previewType === 'audio'" class="preview-box">
        <audio :src="previewContent" controls></audio>
      </div>

      <!-- 视频预览 -->
      <div v-if="previewType === 'video'" class="preview-box">
        <video :src="previewContent" controls></video>
      </div>

      <!-- 错误提示 -->
      <div v-if="previewType === 'unsupported'" class="preview-box">
        <div class="unsupported">⚠️ 不支持该文件格式预览</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilePreview",
  props: {
    // 允许的文件类型
    accept: {
      type: String,
      default: ".pdf,.jpg,.jpeg,.png,.mp3,.wav,.mp4,.avi,.wmv",
    },
    // 外部传入的文件数据（支持File/Blob/ArrayBuffer/文件URL）
    fileData: {
      type: [File, Blob, ArrayBuffer, Object],
      default: null,
    },
    // 文件后缀名（当使用流数据时需指定，例如 'pdf' 或 '.pdf'）
    fileType: {
      type: String,
      default: "",
    },
    style : {
      type: String,
      default: "width: 100%; height: 100%"
    }
  },
  data() {
    return {
      previewType: null,
      previewContent: null,
      isLoading: false,
      objectURLs: [], // 用于存储创建的ObjectURL
    };
  },
  watch: {
    fileData: {
      immediate: true,
      handler(newVal) {
        if (newVal) this.handleExternalFile(newVal);
      },
    },
  },
  mounted() {
    console.log("fileType--------------", this.fileType);
    console.log("fileData-------------", this.fileData);
  },
  methods: {
    // 处理文件选择
    handleFileSelect(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.processFile(file);
    },

    // 修改后的处理逻辑
    async handleExternalFile(data) {
      this.isLoading = true;
      try {
        let processedFile = data;
        console.log("data--------instanceof", data instanceof Blob);
        console.log(
          "data--------instanceof ArrayBuffer",
          data instanceof ArrayBuffer
        );

        // if (data instanceof ArrayBuffer) {
        //   // 新增后缀名转MIME类型逻辑
        //   let mimeType = "application/octet-stream";
        //   if (this.fileType) {
        //     const ext = this.fileType.replace(/^\./, "").toLowerCase();
        //     mimeType = this.getMimeTypeFromExtension(ext);
        //   } else {
        //     mimeType = this.getMimeTypeFromData(data);
        //   }
        //   processedFile = new Blob([data], { type: mimeType });
        // }

        if (processedFile instanceof Blob) {
          this.processFile(processedFile);
        } else if (typeof data === "object" && data.url) {
          this.previewType = this.getFileTypeFromUrl(data.url);
          this.previewContent = data.url;
        }
      } catch (error) {
        console.error("文件处理失败:", error);
        this.previewType = "unsupported";
      }
      this.isLoading = false;
    },
    // 新增后缀名转MIME类型方法
    getMimeTypeFromExtension(ext) {
      const extensionMap = {
        pdf: "application/pdf",
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
        png: "image/png",
        gif: "image/gif",
        mp3: "audio/mpeg",
        wav: "audio/wav",
        mp4: "video/mp4",
        avi: "video/x-msvideo",
        wmv: "video/x-ms-wmv",
      };
      return extensionMap[ext] || "application/octet-stream";
    },

    // 统一处理文件
    processFile(file) {
      // 优化类型判断逻辑
      const typeSource = this.fileType;
      const fileType = this.getFileType(typeSource);
      const typeName = this.getMimeTypeFromExtension(this.fileType);
      console.log("fileType-----统一处理文件---------", typeName);
      // 重新创建 Blob，并指定 type
      const newBlob = new Blob([file], { type: typeName });
      const objectURL = URL.createObjectURL(newBlob);
      this.objectURLs.push(objectURL);

      switch (fileType) {
        case "image":
          this.previewImage(file);
          break;
        case "pdf":
          this.previewType = "pdf";
          this.previewContent = objectURL;
          break;
        case "audio":
          this.previewType = "audio";
          this.previewContent = objectURL;
          break;
        case "video":
          this.previewType = "video";
          this.previewContent = objectURL;
          break;
        default:
          this.previewType = "unsupported";
      }
    },

    // 图片特殊处理（需要DataURL）
    previewImage(file) {
      // const reader = new FileReader();
      // reader.onload = (e) => {
      //   this.previewType = "image";
      //   this.previewContent = e.target.result;
      // };
      // reader.readAsDataURL(file);

      // 生成临时 URL
      const url = URL.createObjectURL(file);
      this.previewType = "image";
      this.previewContent = url;
    },

    // 重构后的类型判断方法
    getFileType(type) {
      // 判断是否为后缀名格式（非MIME类型）
      if (!type.includes("/")) {
        return this.getTypeFromExtension(type);
      }

      // 原始MIME类型判断逻辑
      const mimeTypeMap = {
        "application/pdf": "pdf",
        "image/": "image",
        "audio/": "audio",
        "video/": "video",
      };

      for (const [key, value] of Object.entries(mimeTypeMap)) {
        if (type.startsWith(key)) return value;
      }
      return "unsupported";
    },
    // 新增后缀名判断方法
    getTypeFromExtension(ext) {
      const extensionMap = {
        pdf: "pdf",
        jpg: "image",
        jpeg: "image",
        png: "image",
        gif: "image",
        mp3: "audio",
        wav: "audio",
        mp4: "video",
        avi: "video",
        wmv: "video",
      };
      return extensionMap[ext] || "unsupported";
    },

    // 根据URL后缀判断类型
    getFileTypeFromUrl(url) {
      const extension = url.split(".").pop().toLowerCase();
      const extensionMap = {
        pdf: "pdf",
        jpg: "image",
        jpeg: "image",
        png: "image",
        mp3: "audio",
        wav: "audio",
        mp4: "video",
        avi: "video",
      };
      return extensionMap[extension] || "unsupported";
    },

    // 从二进制数据推测类型
    getMimeTypeFromData(buffer) {
      const signatures = {
        "89504E47": "image/png",
        FFD8FFDB: "image/jpeg",
        FFD8FFE0: "image/jpeg",
        25504446: "application/pdf",
      };

      const uintArr = new Uint8Array(buffer.slice(0, 4));
      const hex = Array.from(uintArr)
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("")
        .toUpperCase();

      return signatures[hex] || "application/octet-stream";
    },
  },
  beforeDestroy() {
    // 清理所有ObjectURL
    this.objectURLs.forEach((url) => URL.revokeObjectURL(url));
    this.objectURLs = [];
  },
};
</script>

<style scoped>
.preview-container {
  padding: 5px;
  border: 1px solid #ddd;
  border-radius: 8px;
  height: 100%;
}

.file-input {
  margin-bottom: 20px;
}

.preview-content {
  position: relative;
  height: 100%;
}

.preview-box {
  width: 100%;
  height: 100%;
  border: 1px solid #eee;
}

.preview-box img {
  max-width: 100%;
  max-height: 100%;
  display: block;
  margin: 0 auto;
}

.pdf-viewer {
  width: 100%;
  height: 100%;
  border: none;
}

.preview-box audio,
.preview-box video {
  width: 100%;
  margin-top: 20px;
}

.unsupported {
  padding: 20px;
  color: #ff4444;
  text-align: center;
}

.preview-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
